const ar = {
    microspec: "مايكروسبيك",
    goBackToHome: "العودة إلى الصفحة الرئيسية",
    signIn: "تسجيل الدخول",
    optional: "اختياري",
    userSettings: "إعدادات المستخدم",
    users: "المستخدمين",
    manageUsers: "إدارة المستخدمين",
    logout: "تسجيل الخروج",
    account: "الحساب",
    security: "الامان",
    firstName: "الاسم الاول",
    lastName: "اسم العائلة",
    emailAddress: "البريد الالكتروني",
    password: "كلمة المرور",
    phone: "رقم الهاتف",
    address: "العنوان",
    save: "حفظ",
    saving: "جارِ الحفظ...",
    dangerZone: "منطقة خطر",
    dangerZoneDeleteAccountText: "اضغط على الزر بالاسفل لحذف الحساب",
    // Login method selection
    selectLoginMethod: "حدد طريقة تسجيل الدخول",
    selectRegistrationMethod: "حدد طريقة التسجيل",
    chooseLoginMethod: "اختر طريقة تسجيل الدخول",
    email: "إيميل",
    phoneNumber: "رقم الهاتف",
    loginError: "خطأ في تسجيل الدخول، يرجى المحاولة مرة أخرى",
    languages: "اللغات",
    languagesBreakdown: "تفصيل اللغات",
    loadingDashboard: "تحميل لوحة التحكم...",
    brandingStatistics: "إحصائيات العلامة التجارية",
    withLogos: "مع الشعارات",
    withBranding: "مع العلامة التجارية",
    currencyStatistics: "إحصائيات العملة",
    totalCurrenciesSupported: "إجمالي العملات المدعومة",
    activityOverview: "نظرة عامة على النشاط",
    organizationsLastMonth: "الأعمال المنشأة الشهر الماضي",
    ofTotal: "من الإجمالي",
    currenciesBreakdown: "تفصيل العملات",
    notifications: "ألإشعارات",
    noNewNotifications: "لا يوجد اشعارات جديدة",
    getResetLinkAfterButtonClick: "اضغط على الزر بالاسفل للحصول على رابط استعادة كلمة المرور للبريد الالكتروني",
    getResetLink: "احصل على رابط لاستعادة كلمة المرور",
    passwordReset: "استعادة كلمة المرور",
    simpleElementText: "لنبني صفحة رائعة بواسطة اساسيات مايكروسبيك",
    pleaseWait: "الرجاء الانتظار",
    deleteAccount: "حذف الحساب",
    cancel: "الغاء",
    confirm: "تأكيد",
    emailOrPasswordInvalid: "البريد الالكتروني او كلمة المرور خطأ",
    rememberMe: "تذكرني",
    forgotPassword: "نسيت كلمة المرور؟",
    newAccount: "حساب جديد؟",
    signUp: "سجلني",
    joinUsToday: "انضم إلينا اليوم",
    signUpError: "حدث خطأ، ربما البريد الإلكتروني مسجل مسبقاً أو كلمة المرور لا تلبي معايير الأمان، يرجى المحاولة مرة أخرى.",
    signUpInProgress: "جارِ إنشاء الحساب...",
    resetLinkSuccessfullySent: "رابط استعادة كلمة المرور أُرسل الى بريدك الالكتروني بنجاح.",
    errorTryLater: "حدثت مشكلة, نأسف لإزعاجك, جرب مرة اخرى لاحقاً.",
    new: "جديد",
    newUnreadNotifications: "لديك {0} اشعارات جديدة",
    deleteAccountConfirmationDialogText: "الرجاء تأكيد حذف الحساب",
    notificationsWaitMessage: "الرجاء الانتظار حتى الانتهاء من جلب الاشعارات",
    viewAll: "اظهار الكل",
    invalidPhone: "رقم الهاتف غير صالح",
    invalidAddress: "العنوان غير صالح",
    aboutYourself: "اكتب عن نفسك",
    pageNotFound: "الصفحة غير موجودة",
    pageNotFoundText: "عذراً, الصفحة التي تبحث عنها غير موجودة.",
    yearsOfExperience: "سنوات من الخبرة",
    welcomeBack: "مرحبًا بعودتك",
    loggingInProgress: "جارِ تسجيل الدخول...",
    formProgress: "تقدم النموذج",
    additionalInformation: "معلومات إضافية",
    // New authentication translations
    signingIn: "جاري تسجيل الدخول...",
    verificationCode: "رمز التحقق",
    otpSentMessage: "تم إرسال رمز التحقق إلى هاتفك",
    verifyAndSignIn: "تحقق وتسجيل الدخول",
    verifying: "جاري التحقق...",
    resendOtp: "إعادة إرسال الرمز",
    sendingOtp: "جاري الإرسال...",
    resendOtpIn: "إعادة إرسال الرمز خلال {seconds} ثانية",
    backToEmailSelection: "العودة لاختيار البريد الإلكتروني",
    backToPhoneSelection: "العودة لاختيار رقم الهاتف",
    userNotFound: "المستخدم غير موجود. يرجى التحقق من البيانات المدخلة.",
    errorCheckingUser: "حدث خطأ أثناء التحقق من المستخدم. يرجى المحاولة مرة أخرى.",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    enterYourPassword: "أدخل كلمة المرور الخاصة بك",
    enterVerificationCode: "أدخل رمز التحقق المرسل",
    // Email verification translations
    verifyEmail: "تحقق من بريدك الإلكتروني",
    verificationEmailSent: "لقد أرسلنا بريد إلكتروني للتحقق إلى",
    checkEmailInstructions: "يرجى التحقق من بريدك الإلكتروني والنقر على رابط التحقق للمتابعة.",
    resendVerification: "إعادة إرسال بريد التحقق",
    verificationEmailResent: "تم إعادة إرسال بريد التحقق بنجاح!",
    verificationEmailError: "فشل في إعادة إرسال بريد التحقق. يرجى المحاولة مرة أخرى.",
    checkVerificationStatus: "لقد تحققت من بريدي الإلكتروني",
    checkingVerificationStatus: "جارِ التحقق من حالة التحقق...",
    checking: "جارِ التحقق...",
    sending: "جارِ الإرسال...",
    emailVerified: "تم التحقق من البريد الإلكتروني!",
    emailVerifiedMessage: "تم التحقق من بريدك الإلكتروني بنجاح. جارِ إعادة التوجيه...",
    didntReceiveEmail: "لم تستلم البريد الإلكتروني؟",
    checkSpamFolder: "تحقق من مجلد الرسائل غير المرغوب فيها أو اضغط على إعادة الإرسال أعلاه.",
    backToLogin: "← العودة إلى تسجيل الدخول",
    tryDifferentEmail: "جرب بريد إلكتروني مختلف →",
    // OTP related translations
    invalidOtp: "رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.",
    otpVerificationFailed: "فشل في التحقق من رمز التحقق. يرجى المحاولة مرة أخرى.",
    failedToResendOtp: "فشل في إعادة إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
    // Profile completion
    completeYourProfile: "أكمل ملفك الشخصي",
    profileCompletionDescription: "يرجى إدخال اسمك الأول والأخير لإكمال التسجيل",
    firstNameRequired: "الاسم الأول مطلوب",
    lastNameRequired: "الاسم الأخير مطلوب",
    completeProfile: "إكمال الملف الشخصي",
    creatingProfile: "جاري إنشاء الملف الشخصي...",
    registrationEmail: "البريد الإلكتروني:",
    registrationPhone: "رقم الهاتف:",
    back: "رجوع",
    emailRegistrationNotAvailable: "تسجيل البريد الإلكتروني غير متاح حاليًا. يرجى استخدام رقم الهاتف.",
    otpSentSuccessfully: "تم إرسال رمز التحقق بنجاح",
    id: "المعرف",
    internalId: "المعرف الداخلي",
    createdAt: "تم الإنشاء",
    updatedAt: "تم التحديث",
    unnamedOrganization: "عمل بلا اسم",
    noDescriptionProvided: "لم يتم تقديم وصف",
    failedToLoadOrganization: "فشل في تحميل الأعمال. يرجى المحاولة مرة أخرى.",
    // 404 Page translations
    notFoundTitle: "عذرًا! تهنا في الفضاء الرقمي",
    notFoundSubtitle: "الصفحة التي تبحث عنها قد انجرفت إلى الفراغ الرقمي. لا تقلق، حتى أفضل المستكشفين يأخذون منعطفًا خاطئًا أحيانًا!",
    notFoundBackToHome: "العودة للصفحة الرئيسية",
    notFoundTryAgain: "حاول مرة أخرى",
    notFoundQuickNavigation: "التنقل السريع",
    notFoundErrorCode: "خطأ 404",
    notFoundPageLabel: "الصفحة غير موجودة",
    notFoundHome: "الصفحة الرئيسية",
    dragNDrop: "اسحب وأفلت بعض الملفات هنا، أو انقر لتحديد الملفات",
    // Authentication error messages
    failedToSendOtp: "فشل في إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
    failedToSendVerificationCode: "فشل في إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
    failedToCreateProfile: "فشل في إنشاء الملف الشخصي. يرجى المحاولة مرة أخرى.",
    userAuthenticationMissing: "معلومات المصادقة مفقودة",
    noConfirmationResult: "لم يتم العثور على نتيجة التأكيد. يرجى المحاولة مرة أخرى.",
    // Loader messages
    loadingInitialData: "جاري تحميل البيانات الأولية...",
    loadingApplicationData: "جاري تحميل بيانات التطبيق...",
    loadingUserProfile: "جاري تحميل ملف المستخدم...",
    // Registration messages
    createNewAccount: "إنشاء حساب جديد",
    createNewPasswordDescription: "إنشاء كلمة مرور جديدة لحسابك",
    enterNewPassword: "أدخل كلمة مرور جديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    newAccountCreationNotice: "سيتم إنشاء حساب جديد بهذا البريد الإلكتروني",
    passwordRequirements: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
    creatingAccount: "جاري إنشاء الحساب...",
    createAccount: "إنشاء الحساب",
    registrationError: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordTooShort: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    emailAlreadyInUse: "هذا البريد الإلكتروني مسجل بالفعل. يرجى تسجيل الدخول بدلاً من ذلك.",
    invalidEmail: "عنوان البريد الإلكتروني غير صالح",
    newAccountAutoCreationNoticeForEmail: "إذا لم يكن هناك حساباً مسجلاً لهذا البريد الإلكتروني، سيتم تنبيهك لإنشاء حساب جديد وستتلقى إرشادات عبر عملية التسجيل",
    newAccountAutoCreationNoticeForPhone: "إذا لم يكن هناك حساباً مسجلاً لهذا الرقم، سيتم تنبيهك لإنشاء حساب جديد وستتلقى إرشادات عبر عملية التسجيل",
    // Account form translations
    updateYourAccountInfo: "تحديث معلومات حسابك وتفضيلاتك",
    personalInformation: "المعلومات الشخصية",
    contactInformation: "معلومات الاتصال",
    fieldRequired: "هذا الحقل مطلوب",
    pleaseFixErrors: "يرجى إصلاح الأخطاء قبل الإرسال",
    profileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح!",
    verifiedField: "هذا الحقل تم التحقق منه ولا يمكن تغييره",
    // Profile picture translations
    changeProfilePicture: "تغيير صورة الملف الشخصي",
    selectProfilePicture: "اختر صورة الملف الشخصي",
    selectImageDescription: "اختر صورة لتحميلها كصورة ملفك الشخصي. ستتمكن من قصها وتعديلها قبل الحفظ.",
    clickToUpload: "انقر للتحميل",
    selectImage: "اختر صورة",
    cropYourImage: "اقتصاص الصورة",
    uploadingProfilePicture: "جاري تحميل صورة الملف الشخصي...",
    profilePictureUpdated: "تم تحديث صورة الملف الشخصي بنجاح!",
    failedToUpdateProfilePicture: "فشل في تحديث صورة الملف الشخصي. يرجى المحاولة مرة أخرى.",
    invalidFileType: "يرجى اختيار ملف صورة",
    fileTooLarge: "حجم الملف يجب أن يكون أقل من 10 ميجابايت",
    selectDifferent: "اختر صورة مختلفة",
    saveProfilePicture: "حفظ صورة الملف الشخصي",
    // Generic image upload translations
    uploadImage: "تحميل صورة",
    imageUploadedSuccessfully: "تم تحميل الصورة بنجاح!",
    failedToUploadImage: "فشل في تحميل الصورة. يرجى المحاولة مرة أخرى.",
    uploadingImage: "جاري تحميل الصورة...",
    saveImage: "حفظ الصورة",
    changeProfilePictureDescription: "اختر صورة لتحميلها كصورة ملفك الشخصي. ستتمكن من قصها وتعديلها قبل الحفظ.",
    // Logo upload translations
    uploadLogo: "تحميل الشعار",
    changeLogo: "تغيير الشعار",
    uploadLogoDescription: "اختر صورة لتحميلها كشعار. ستتمكن من قصها وتعديلها قبل الحفظ.",
    logo: "الشعار",
    // User existence messages
    userAlreadyExists: "هذا الحساب موجود بالفعل. يرجى تسجيل الدخول بدلاً من ذلك.",
    userNotFoundPleaseRegister: "لم يتم العثور على حساب بهذه المعلومات. يرجى التسجيل أولاً.",
    dashboard: "لوحة التحكم",
    systemAdminDashboard: "لوحة تحكم مسؤول النظام",
    // Organization management translations
    organizationName: "اسم المنظمة",
    organizationDescription: "وصف المنظمة",
    organizations: "المنظمات",
    manageOrganization: "إدارة المنظمات",
    addOrganization: "إضافة منظمة",
    editOrganization: "تعديل منظمة",
    loadingOrganization: "جاري تحميل المنظمة...",
    noOrganizationFound: "لم يتم العثور على منظمات.",
    loadMore: "تحميل المزيد",
    createFirstOrganization: "أنشئ أول منظمة",
    createOrganization: "إنشاء منظمة",
    // Branch management translations
    branches: "الفروع",
    manageBranches: "إدارة الفروع",
    addBranch: "إضافة فرع",
    loadingBranches: "جاري تحميل الفروع...",
    editBranch: "تعديل الفرع",
    branchName: "اسم الفرع",
    branchNameRequired: "اسم الفرع *",
    branchNameIsRequired: "اسم الفرع مطلوب",
    branchNotFound: "الفرع غير موجود",
    failedToLoadBranch: "فشل تحميل بيانات الفرع",
    failedToSaveBranch: "فشل حفظ الفرع",
    branchUpdatedSuccessfully: "تم تحديث الفرع بنجاح!",
    branchCreatedSuccessfully: "تم إنشاء الفرع بنجاح!",
    updateBranchInfo: "تحديث معلومات وإعدادات الفرع",
    fillBranchDetails: "املأ التفاصيل لإنشاء فرع جديد",
    updateBranch: "تحديث الفرع",
    createBranch: "إنشاء فرع",
    location: "الموقع",
    city: "المدينة",
    state: "الولاية/المحافظة",
    zipCode: "الرمز البريدي",
    country: "البلد",
    // UpsertOrganization component
    organizationNotFound: "لم يتم العثور على المنظمة",
    basicInformation: "المعلومات الأساسية",
    organizationNameRequired: "اسم المنظمة *",
    industry: "الصناعة",
    selectIndustry: "اختر الصناعة",
    description: "الوصف",
    organizationDescriptionPlaceholder: "أدخل وصفاً موجزاً لمنظمتك...",
    emailAddressRequired: "عنوان البريد الإلكتروني *",
    branding: "العلامة التجارية",
    remove: "إزالة",
    primaryColor: "اللون الأساسي",
    secondaryColor: "اللون الثانوي",
    settings: "الإعدادات",
    primaryCurrency: "العملة الأساسية",
    supportedCurrencies: "العملات المدعومة",
    localization: "الترجمة",
    language: "اللغة",
    preferredLanguage: "اللغة المفضلة",
    supportedLanguages: "اللغات المدعومة",
    updateOrganizationInfo: "تحديث معلومات المنظمة والإعدادات",
    fillOrganizationDetails: "املأ التفاصيل لإنشاء منظمة جديدة",
    organizationUpdatedSuccessfully: "تم تحديث المنظمة بنجاح!",
    organizationCreatedSuccessfully: "تم إنشاء المنظمة بنجاح!",
    organizationNameIsRequired: "اسم المنظمة مطلوب",
    contactEmailIsRequired: "بريد الاتصال الإلكتروني مطلوب",
    pleaseEnterValidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
    pleaseEnterValidPhone: "يرجى إدخال رقم هاتف صالح",
    pleaseEnterValidHexColor: "يرجى إدخال لون سادس عشري صالح",
    pleaseSelectImageFile: "يرجى اختيار ملف صورة",
    imageSizeLessThan5MB: "يجب أن يكون حجم الصورة أقل من 5 ميجابايت",
    pleaseFixFormErrors: "يرجى إصلاح أخطاء النموذج قبل الإرسال",
    userNotAuthenticated: "المستخدم غير مصدق عليه",
    systemError: "خطأ في النظام. يرجى المحاولة مرة أخرى لاحقاً.",
    organizationInfoMissing: "معلومات المنظمة مفقودة.",
    organizationOwnershipInfoMissing: "معلومات ملكية المنظمة غير متوفرة.",
    unauthorized: "ليس لديك صلاحية للوصول إلى هذه الصفحة.",
    verificationError: "حدث خطأ أثناء التحقق من صلاحيتك. يرجى المحاولة مرة أخرى.",
    accessDenied: "الوصول مرفوض",
    failedToSaveOrganization: "فشل في حفظ المنظمة",
    updating: "جاري التحديث...",
    updateOrganization: "تحديث المنظمة",
    creating: "جاري الإنشاء...",
    restaurant: "مطعم",
    technology: "التكنولوجيا",
    healthcare: "الرعاية الصحية",
    finance: "المالية",
    education: "التعليم",
    retail: "التجزئة",
    manufacturing: "التصنيع",
    construction: "البناء",
    foodAndBeverage: "الأغذية والمشروبات",
    transportation: "النقل",
    realEstate: "العقارات",
    marketing: "التسويق",
    consulting: "الاستشارات",
    other: "أخرى",
    arabicSaudi: "العربية (السعودية)",
    hebrewIsrael: "العبرية (إسرائيل)",
    englishUS: "الإنجليزية (الولايات المتحدة)",
    totalOrganization: "إجمالي الأعمال",
    totalUsers: "إجمالي المستخدمين",
    of: "من",
    rowsPerPage: "عدد الصفوف في كل صفحة",
    search: "بحث",
    items: "عناصر",
    noDataAvailable: "لا توجد بيانات متاحة",
    actions: "إجراءات",
    refresh: "تحديث",
    export: "تصدير",
    columnSettings: "إعدادات الأعمدة",
    selected: "محدد",
    moreThan: "أكثر من",
    exportData: "تصدير البيانات",
    exportFormat: "صيغة التصدير",
    exportScope: "نطاق التصدير",
    currentPage: "الصفحة الحالية",
    pageRange: "نطاق الصفحات",
    allPages: "جميع الصفحات",
    fromPage: "من صفحة",
    toPage: "إلى صفحة",
    exportInfo: "معلومات التصدير",
    // Organization Context
    workspaceContext: "سياق مساحة العمل",
    selectOrganization: "اختر المنظمة",
    selectBranch: "اختر الفرع",
    allBranches: "جميع الفروع",
    currentContext: "السياق الحالي",
    noOrganizationMembership: "لست عضوًا في أي منظمة",
    noOrganizationMembershipDescription: "تحتاج إلى دعوة إلى منظمة للوصول إلى لوحة التحكم هذه.",
    loadingOrganizationContext: "جاري تحميل سياق مساحة العمل...",
    retry: "إعادة المحاولة",
    roles: "أدوار",
    nextSteps: "الخطوات التالية",
    contactOrganizationAdmin: "الاتصال بمسؤول المنظمة",
    contactOrganizationAdminDescription: "تواصل مع مسؤول منظمتك لطلب الوصول.",
    waitForInvitation: "انتظر الدعوة",
    waitForInvitationDescription: "بمجرد دعوتك، ستتمكن من الوصول إلى لوحة المعلومات وميزاتها.",
    checkForMemberships: "التحقق من العضويات",
    organizationsManager: "مدير المنظمة",
    // UpsertMemberToOrganization component
    assignMemberToOrganization: "إضافة عضو إلى المنظمة",
    findUser: "البحث عن مستخدم",
    assignRoles: "تعيين الأدوار",
    organizationIdRequired: "معرف المنظمة مطلوب",
    failedToValidateIds: "فشل التحقق من معرفات المنظمة/الفرع",
    pleaseEnterSearchValue: "يرجى إدخال بريد إلكتروني أو رقم هاتف",
    failedToSearchUser: "فشل البحث عن المستخدم",
    pleaseSelectUser: "يرجى اختيار مستخدم",
    pleaseSelectAtLeastOneRole: "يرجى اختيار دور واحد على الأقل",
    failedToAssignMember: "فشل تعيين العضو",
    memberAlreadyInBranch: "العضو موجود بالفعل في الفرع المحدد",
    memberAssignedSuccessfully: "تم تعيين العضو بنجاح",
    userAddedToOrgAndBranch: "تمت إضافة المستخدم إلى المنظمة والفرع مع الأدوار المحددة.",
    userAddedToOrg: "تمت إضافة المستخدم إلى المنظمة مع الأدوار المحددة.",
    addAnotherMember: "إضافة عضو آخر",
    close: "إغلاق",
    findUserToAdd: "البحث عن مستخدم للإضافة",
    searchByEmail: "البحث بالبريد الإلكتروني",
    searchByPhone: "البحث برقم الهاتف",
    searchByEmailOrPhone: "البحث بالبريد الإلكتروني أو رقم الهاتف",
    searchResults: "نتائج البحث",
    selectRolesForMember: "اختر الأدوار التي تريد تعيينها لهذا العضو.",
    organizationRoles: "أدوار المنظمة",
    branchRoles: "أدوار الفرع",
    confirmAssignment: "تأكيد التعيين",
    user: "المستخدم",
    memberWillReceiveNotification: "سيتلقى العضو إشعاراً بدوره الجديد.",
    assignMember: "تعيين العضو",
    next: "التالي",
    validatingInformation: "جاري التحقق من المعلومات...",
    userAlreadyOrgMember: "هذا المستخدم عضو نشط بالفعل في هذه المنظمة",
    userAlreadyOrgMemberCanAddToBranch: "هذا المستخدم عضو بالفعل في المنظمة وسيتم إضافته إلى الفرع المحدد",
    userAlreadyBranchMember: "هذا المستخدم عضو نشط بالفعل في هذا الفرع",
    selectOrganizationAndBranch: "اختر المنظمة والفرع",
    selectBranchOptional: "اختر الفرع (اختياري)",
    pleaseSelectOrganization: "يرجى اختيار منظمة",
    failedToLoadOrganizations: "فشل تحميل المنظمات",
    userWillBeAssignedToBranch: "سيتم تعيين المستخدم إلى المنظمة والفرع المحددين",
    userWillBeAssignedToOrg: "سيتم تعيين المستخدم إلى المنظمة المحددة فقط",
    selectedUser: "المستخدم المحدد",
    userFound: "تم العثور على المستخدم",
    identifier: "المعرّف",
    authenticationMethod: "طريقة المصادقة",
    availableMethods: "الطرق المتاحة",
    errorSearchingUser: "حدث خطأ أثناء البحث عن المستخدم. يرجى المحاولة مرة أخرى.",
    // ManageMembers component
    branchMembers: "أعضاء الفرع",
    organizationMembers: "أعضاء المنظمة",
    noBranchesFound: "لم يتم العثور على فروع",
    unnamedBranch: "فرع بلا اسم",
    memberAddedSuccessfully: "تمت إضافة العضو بنجاح",
    memberSuspended: "تم تعليق العضو بنجاح",
    memberActivated: "تم تفعيل العضو بنجاح",
    memberRemoved: "تمت إزالة العضو بنجاح",
    failedToUpdateMember: "فشل تحديث العضو",
    failedToRemoveMember: "فشلت إزالة العضو",
    member: "عضو",
    manageMembers: "إدارة الأعضاء",
    status: "الحالة",
    noRoles: "لا توجد أدوار مخصصة",
    active: "نشط",
    suspended: "معلق",
    invited: "مدعو",
    transferred: "منقول",
    joinedAt: "تاريخ الانضمام",
    notYetJoined: "لم ينضم بعد",
    addedOn: "أضيف في",
    addMember: "إضافة عضو",
    suspend: "تعليق",
    activate: "تفعيل",
    noMembers: "لم يتم العثور على أعضاء",
    suspendMember: "تعليق العضو",
    activateMember: "تفعيل العضو",
    suspendMemberConfirm: "هل أنت متأكد أنك تريد تعليق هذا العضو؟ سيفقد الوصول إلى المنظمة/الفرع.",
    activateMemberConfirm: "هل أنت متأكد أنك تريد تفعيل هذا العضو؟ سيستعيد الوصول إلى المنظمة/الفرع.",
    removeMember: "إزالة العضو",
    removeMemberWarning: "لا يمكن التراجع عن هذا الإجراء. ستتم إزالة العضو بشكل دائم.",
    removeMemberConfirm: "هل أنت متأكد أنك تريد إزالة هذا العضو؟",
    processing: "جاري المعالجة...",
    unknownUser: "مستخدم غير معروف",
    loading: "جاري التحميل...",
    ecommerceBusinessManager: "مدير المتجر الإلكتروني",
    manageModules: "إدارة الوحدات",
    modules: "الوحدات",
    addModule: "إضافة وحدة",
    enablableModules: "الوحدات القابلة للتفعيل",
    manageSystemModules: "قم بتمكين أو تعطيل وحدات النظام لتخصيص تجربة النظام الأساسي الخاص بك",
    enabled: "مفعّل",
    disabled: "معطل",
    organizationContextAware: "مدرك لسياق المنظمة",
    noEnablableModules: "لا توجد وحدات قابلة للتفعيل",
    noModulesAvailable: "لا توجد حاليًا وحدات متاحة للتمكين أو التعطيل",
    enableModule: "تفعيل الوحدة",
    disableModule: "تعطيل الوحدة",
    enableModuleConfirmation: "سيؤدي هذا إلى تفعيل الوحدة لمدة 14 يومًا. ستكون الوحدة متاحة لمؤسستك خلال هذه الفترة.",
    disableModuleConfirmation: "سيؤدي هذا إلى تعطيل الوحدة فورًا. لن يتمكن المستخدمون من الوصول إلى ميزات هذه الوحدة.",
    module: "الوحدة",
    activePeriod: "الفترة النشطة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    // Module access control translations
    moduleNotEnabled: "الوحدة غير مفعّلة",
    moduleNotEnabledDescription: "هذه الوحدة غير مفعّلة حالياً لمنظمتك. يرجى الاتصال بمسؤول النظام لتفعيل الوصول إلى هذه الميزة.",
    requestedModule: "الوحدة المطلوبة",
    currentOrganization: "المنظمة الحالية",
    moduleEnableInstructions: "لتفعيل هذه الوحدة، قم بزيارة صفحة إدارة الوحدات في إعدادات مسؤول المنظمة وقم بتنشيطها لمنظمتك.",
    goToModules: "الانتقال إلى الوحدات",
    goBack: "العودة",
    // Organizational Layout translations
    loadingOrganizationData: "جاري تحميل بيانات المنظمة...",
    illegalState: "طلب غير صالح",
    illegalStateDescription: "تتطلب هذه الصفحة معلومات منظمة صالحة لعرض المحتوى. يرجى الوصول إلى هذه الصفحة من خلال التنقل المناسب.",
    organizationNotFoundDescription: "المنظمة التي تبحث عنها غير موجودة أو تمت إزالتها. يرجى التحقق من معرف المنظمة والمحاولة مرة أخرى.",
    branchNotFoundForOrganization: "الفرع غير موجود",
    branchNotFoundForOrganizationDescription: "الفرع المطلوب غير موجود ضمن هذه المنظمة. ربما تمت إزالته أو معرف الفرع غير صحيح.",
    unexpectedError: "حدث خطأ ما",
    unexpectedErrorDescription: "حدث خطأ غير متوقع أثناء تحميل بيانات المنظمة. يرجى المحاولة مرة أخرى لاحقًا أو الاتصال بالدعم إذا استمرت المشكلة.",
    // Permissions Management translations
    permissionsManagement: "إدارة الصلاحيات",
    permissionsManagementDescription: "عرض ومزامنة صلاحيات النظام مع قاعدة البيانات",
    manageAuthentication: "إدارة المصادقة",
    filterByModule: "التصفية حسب الوحدة",
    allModules: "جميع الوحدات",
    synced: "متزامن",
    notSynced: "غير متزامن",
    syncAll: "مزامنة الكل",
    syncing: "جاري المزامنة...",
    syncToDatabase: "مزامنة مع قاعدة البيانات",
    permissionId: "معرف الصلاحية",
    displayName: "الاسم المعروض",
    total: "الإجمالي",
    // Permission names
    category: "الفئة",
    manageOrganizationsPermission: "إدارة المنظمات",
    manageOrganizationsPermissionDesc: "إنشاء وتحرير وحذف المنظمات",
    manageUsersPermission: "إدارة المستخدمين",
    manageUsersPermissionDesc: "إنشاء وتحرير وإدارة حسابات المستخدمين",
    manageModulesPermission: "إدارة الوحدات",
    manageModulesPermissionDesc: "تفعيل أو تعطيل وحدات النظام",
    managePermissionsPermission: "إدارة الصلاحيات",
    managePermissionsPermissionDesc: "تكوين وتعيين الصلاحيات",
    manageProductsPermission: "إدارة المنتجات",
    manageProductsPermissionDesc: "إنشاء وتحرير وإدارة كتالوج المنتجات",
    manageOrdersPermission: "إدارة الطلبات",
    manageOrdersPermissionDesc: "عرض ومعالجة طلبات العملاء",
    viewAnalyticsPermission: "عرض التحليلات",
    viewAnalyticsPermissionDesc: "الوصول إلى تحليلات وتقارير الأعمال",
    manageCustomersPermission: "إدارة العملاء",
    manageCustomersPermissionDesc: "عرض وإدارة معلومات العملاء",
    noPermissionsFound: "لم يتم العثور على صلاحيات",
    all: "الكل",
    createdWithLove: "صنع بكل حب ❤️ بواسطة مايكروسبيك",
    copyrightsReserved: "جميع الحقوق محفوظة",
    learnMore: "إعرف المزيد",
    faqTitle: "الأسئلة الشائعة",
    faqSubtitle: "ابحث عن إجابات للأسئلة الشائعة حول خدماتنا",
    faqSearchPlaceholder: "ابحث عن سؤال...",
    noFaqSearchResults: "لم يتم العثور على نتائج للأسئلة الشائعة",
    lightMode: "الوضع الفاتح",
    darkMode: "الوضع الداكن",
    contactUs: "اتصل بنا",
    submit: "إرسال",
    clear: "مسح",
    formSuccessMessage: "تم إرسال النموذج بنجاح!",
    fullName: "الاسم الكامل",
    message: "الرسالة",
    // Localized Input
    localizedInputManageLocalizations: "إدارة الترجمات",
    localizedInputClickIconToLocalize: "انقر على أيقونة اللغة للترجمة لجميع اللغات",
    localizedInputEditAllLanguages: "تحرير القيم لجميع اللغات المدعومة",
    localizedInputPreferred: "المفضل",
    localizedInputEnterValue: "أدخل القيمة",
}

const getArabicMap = () => {
    return ar
}

export default getArabicMap
